module.exports = __webpack_public_path__ + "media/Components/fonts/boldPlayfairDisplay-942b980e28bf8d1761082ce951ed0e30.ttf";